"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var zipCodeFormats = {
    AU: {
        formats: ['1111'],
    },
    CA: {
        formats: ['A1A 1A1'],
    },
    DE: {
        formats: [
            '11111',
        ],
    },
    FR: {
        formats: [
            '11111',
        ],
    },
    GB: {
        formats: [
            'A1 1AA',
            'A11 1AA',
            'AA1 1AA',
            'AA11 1AA',
            'A1A 1AA',
            'AA1A 1AA',
        ],
    },
    GR: {
        formats: ['111 11'],
    },
    HK: {
        none: true,
    },
    IE: {
        formats: [
            '',
            'A1X XXXX',
        ],
    },
    KR: {
        formats: [
            '11111',
        ],
    },
    NL: {
        formats: [
            '1111 AA',
        ],
    },
    JP: {
        formats: [
            '111-1111',
        ],
    },
    US: {
        formats: ['11111', '11111-1111'],
    },
};
exports.default = zipCodeFormats;
